module.exports = __webpack_public_path__ + "img/04.62b5e5fa.jpg";